<mat-form-field [ngClass]="errorStateMatcher?.validationClass ?? 'valid'">
    <mat-label appRemoveAriaOwns>{{ property.displayKey ? property.Key : '' }}</mat-label>
    <span
        matPrefix
        *ngIf="property.hasIcon"
        ><i class="{{ property.iconClass }}"></i
    ></span>
    <input
        nbInput
        matInput
        type="text"
        [matTimepicker]="timepicker"
        [(ngModel)]="property.Value"
        (ngModelChange)="errorStateMatcher?.markAsInteracted()"
        (blur)="errorStateMatcher?.markAsInteracted()"
        [errorStateMatcher]="errorStateMatcher"
    />
    <mat-timepicker
        #timepicker
        interval="30min"
    ></mat-timepicker>
    <mat-hint>{{ property.hint }}</mat-hint>
    <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
</mat-form-field>
